import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Table from '../../../../Layout/Table';
import {
  resetTablePagination,
  getTablePaginationData,
} from '../../../../../core/actions';
import { getPagAssocDetails } from '../../../../../core/apiRequests';
import '../../associates.css';

const getTableName = type => `ASSOC_PAG_TABLE_${type}`;

const AssocPagTable = props => {
  const [tableData, setData] = useState([]);
  const isMounted = useRef(null);
  const tableName = getTableName(props.type);

  // Data-fetching: runs when pagination state changes, but only after initialization
  useEffect(() => {
    setData([]);
    if (props.auth.merchantId && props.pagination.sortColumn) {
      getTheData();
    }
    return () => {
      isMounted.current = false;
    };
  }, [
    props.type,
    props.auth.merchantId,
    props.pagination.sortColumn,
    props.pagination.pageSize,
    props.pagination.page,
    props.pagination.ascendingColumn,
  ]);

  // Initialization: sets correct pagination state atomically on mount/tab switch
  useEffect(() => {
    const {
      firstSort,
      firstAscend,
      auth: { merchantId },
    } = props;
    if (merchantId) {
      setData([]);
      resetTablePagination(
        { sortColumn: firstSort, ascendingColumn: firstAscend || false },
        tableName,
      );
    }
  }, [props.type, props.auth.merchantId]);

  const getTheData = () => {
    const {
      type,
      auth: { merchantId },
      pagination: { page, pageSize, sortColumn, ascendingColumn },
    } = props;

    (async () => {
      const dataArr = await getPagAssocDetails(
        tableName,
        props.match.params.associateId,
        merchantId,
        page,
        pageSize,
        sortColumn,
        ascendingColumn,
        type,
      );
      if (dataArr) {
        setData(dataArr);
      }
    })();
  };

  return (
    <Table
      tableContainerClass="table-content-tabbed-head"
      tableClassName="lg-table-sidebar table-content-tabbed-head rem-pad-width"
      data={tableData}
      style={window.location.href.includes('associate-reminders') ? { width: '100%' } : {}}
      tableStyles={window.location.href.includes('associate-reminders') ? { border: 'none' } : {}}
      tableHeaders={props.tableHeaders}
      searchable={false}
      paginationV2
      tableName={tableName}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  pagination: getTablePaginationData(state, getTableName(ownProps.type)),
  auth: state.auth,
  associate: state.associate,
});
export default connect(mapStateToProps, {})(AssocPagTable);
